import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import IndiaMap from '../IndiaMap';

export default function DealersSection() {
  const { t } = useLanguage();
  return (
    <section data-testid="dealers-section" className="py-16 lg:py-24" style={{ backgroundColor: '#F9F8F4' }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
              style={{ backgroundColor: '#FEF3C7', color: '#D97706', border: '1px solid #FDE68A' }}>
              {t.dealers.badge}
            </span>
            <h2 className="font-heading font-black text-3xl sm:text-4xl leading-tight mb-2" style={{ color: '#0A3F22' }}>
              {t.dealers.title}
            </h2>
            <h2 className="font-heading font-black text-3xl sm:text-4xl leading-tight mb-4" style={{ color: '#D97706' }}>
              {t.dealers.title2}
            </h2>
            <p className="text-sm leading-relaxed mb-6" style={{ color: '#4A554A' }}>{t.dealers.description}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {t.dealers.benefits.map((b, i) => (
                <motion.div
                  key={b}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="flex items-start gap-2 p-3 bg-white rounded-lg border"
                  style={{ borderColor: '#E5E7EB' }}
                >
                  <CheckCircle size={16} className="flex-shrink-0 mt-0.5" style={{ color: '#1B6B3D' }} />
                  <span className="text-sm font-medium" style={{ color: '#1A1C1A' }}>{b}</span>
                </motion.div>
              ))}
            </div>

            <Link
              to="/dealers"
              data-testid="dealers-cta"
              className="inline-block px-8 py-4 rounded-lg font-heading font-bold text-white text-base transition-all duration-300 hover:scale-105"
              style={{ backgroundColor: '#0A3F22', boxShadow: '0 4px 20px rgba(10,63,34,0.3)' }}
            >
              {t.dealers.cta} →
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-6 shadow-sm border flex flex-col items-center"
            style={{ borderColor: '#E5E7EB' }}
          >
            <h3 className="font-heading font-bold text-lg mb-1 self-start" style={{ color: '#0A3F22' }}>Our Dealer Network</h3>
            <p className="text-xs mb-4 self-start" style={{ color: '#4A554A' }}>Active coverage across key Indian states</p>
            <IndiaMap />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
